import { render, staticRenderFns } from "./MyAnnouncements.vue?vue&type=template&id=8c79afb2"
import script from "./MyAnnouncements.vue?vue&type=script&lang=js"
export * from "./MyAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports